import { useEffect, useState } from 'react';
import { FileText, AlertCircle, ListChecks, Briefcase, Gauge } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { qmsAPI } from '../../lib/regulatoryAPI';

const Metric = ({ icon: Icon, label, value, testId, onClick }) => (
  <button type="button" onClick={onClick} disabled={!onClick} data-testid={testId}
    className="flex items-center gap-3 rounded-lg border bg-card p-4 text-left transition-colors hover:bg-muted/50 disabled:cursor-default">
    <Icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
    <div><p className="text-xs text-muted-foreground">{label}</p><p className="text-xl font-semibold capitalize">{value}</p></div>
  </button>
);

export const QMSMetricsCard = ({ onNavigate }) => {
  const [m, setM] = useState(null);
  useEffect(() => { qmsAPI.dashboard().then(setM).catch(() => setM(false)); }, []);
  if (m === false) return null;
  return (
    <Card data-testid="qms-metrics-card">
      <CardContent className="grid gap-3 pt-6 sm:grid-cols-2 lg:grid-cols-5">
        <Metric icon={FileText} label="Published policies" value={m?.total_policies ?? '–'} testId="qms-metric-policies" onClick={() => onNavigate('policies')} />
        <Metric icon={AlertCircle} label="Open incidents" value={m?.open_incidents ?? '–'} testId="qms-metric-incidents" onClick={() => onNavigate('incidents')} />
        <Metric icon={ListChecks} label="Open actions" value={m?.open_remediation_actions ?? '–'} testId="qms-metric-actions" />
        <Metric icon={Briefcase} label="High-risk engagements" value={m?.high_risk_engagements ?? '–'} testId="qms-metric-high-risk" onClick={() => onNavigate('engagement-risk')} />
        <Metric icon={Gauge} label="Firm risk level" value={m?.firm_risk_level ?? '–'} testId="qms-metric-firm-risk" />
      </CardContent>
    </Card>
  );
};
